import React from 'react';
import TextAdapter from './TextAdapter';
import { AdapterProps } from '../types';

const ColorAdapter = (props: AdapterProps['color']) => (
  <TextAdapter {...props} type="color" />
);

export default ColorAdapter;
